import "./logo-component-styles.scss";

const LogoComponent = () => {
    return (
        <div className="logo-box">
            <a title="Moazam Dev Logo" href="https://moazamdev.vercel.app">
                <img href="#" src={require("../../assets/m_dev.png")} alt="" />
            </a>
        </div>
    );
}

export default LogoComponent;